import { render, staticRenderFns } from "./RealtimeEntries.vue?vue&type=template&id=078f87d4"
import script from "./RealtimeEntries.vue?vue&type=script&lang=js"
export * from "./RealtimeEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports